import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '@mhe/reader/common/button';
import { TranslateModule } from '@ngx-translate/core';

import { TooltipModule } from '../../../common/directives/tooltip';
import { ModalHeaderComponent } from './modal-header.component';

@NgModule({
  imports: [ButtonModule, TranslateModule, CommonModule, TooltipModule],
  declarations: [ModalHeaderComponent],
  exports: [ModalHeaderComponent],
})
export class ReaderModalHeaderModule {}
